import { Modal } from 'antd';
import { useState } from "react";
import Mispichoshelper from "../../utils/Mispichoshelper";
import AddressAutoComplete from "../common/AdressAutoComplete";

const OrderUserAddress = (props) => {

  const [loading, setLoading] = useState(false);

  const receiveAdress = (address) => {
    setLoading(true);
    Mispichoshelper.postAltaDomicilioPerfil({ address: address, usuario_id: props.compra.cliente_id }).then(informaResponse);
  }

  const informaResponse = (response) => {
    setLoading(false);

    if (response.payload.status) {
      Modal.success({
        title: response.payload.title,
        content: response.payload.message,
        onOk: props.hideAltaDomicilio,
        okText: 'Entendido'
      });
    } else {
      Modal.error({
        title: response.payload.title,
        content: response.payload.message,
        onOk: props.hideAltaDomicilio,
      });
    }
  }

  const showManager = (status) => {
    if (status) return;
    else props.hideAltaDomicilio()
  }

  return (

    <AddressAutoComplete
      loading={loading}
      show={props.showAltaDomicilio}
      setShow={(status) => showManager(status)}
      receiveAdress={receiveAdress}
    />
  )
}
export default OrderUserAddress;
